/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type {
  Signer,
  AddressLike,
  ContractDeployTransaction,
  ContractRunner,
} from "ethers";
import type { NonPayableOverrides } from "../../common";
import type {
  TimeFrameOracle,
  TimeFrameOracleInterface,
} from "../../contracts/TimeFrameOracle";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "dataWriter_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "TimeframeOracle_InvalidTimeFrame",
    type: "error",
  },
  {
    inputs: [],
    name: "TimeframeOracle_OnlyWriter",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [],
    name: "FrameReset",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "ITimeFrameOracle.Time",
        name: "startTime",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "ITimeFrameOracle.Time",
        name: "endTime",
        type: "uint256",
      },
    ],
    name: "FrameSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "writer",
        type: "address",
      },
    ],
    name: "WriterSet",
    type: "event",
  },
  {
    inputs: [],
    name: "DATA_WRITER",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getEnd",
    outputs: [
      {
        internalType: "ITimeFrameOracle.Time",
        name: "endTime",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getStart",
    outputs: [
      {
        internalType: "ITimeFrameOracle.Time",
        name: "startTime",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTimeFrame",
    outputs: [
      {
        components: [
          {
            internalType: "ITimeFrameOracle.Time",
            name: "startTime",
            type: "uint256",
          },
          {
            internalType: "ITimeFrameOracle.Time",
            name: "endTime",
            type: "uint256",
          },
        ],
        internalType: "struct ITimeFrameOracle.TimeFrame",
        name: "timeFrame",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "reset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "ITimeFrameOracle.Time",
            name: "startTime",
            type: "uint256",
          },
          {
            internalType: "ITimeFrameOracle.Time",
            name: "endTime",
            type: "uint256",
          },
        ],
        internalType: "struct ITimeFrameOracle.TimeFrame",
        name: "timeFrame",
        type: "tuple",
      },
    ],
    name: "setFrame",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "dataWriter",
        type: "address",
      },
    ],
    name: "setWriter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type TimeFrameOracleConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TimeFrameOracleConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TimeFrameOracle__factory extends ContractFactory {
  constructor(...args: TimeFrameOracleConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    dataWriter_: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(dataWriter_, overrides || {});
  }
  override deploy(
    dataWriter_: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(dataWriter_, overrides || {}) as Promise<
      TimeFrameOracle & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): TimeFrameOracle__factory {
    return super.connect(runner) as TimeFrameOracle__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TimeFrameOracleInterface {
    return new Interface(_abi) as TimeFrameOracleInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): TimeFrameOracle {
    return new Contract(address, _abi, runner) as unknown as TimeFrameOracle;
  }
}
